const config = {
  defaultPath: '/Dashboard',
  fontFamily: `'Public Sans', sans-serif`,
  i18n: 'en',
  miniDrawer: false,
  container: true,
  mode: 'light',
  presetColor: 'default',
  themeDirection: 'ltr',
};

export default config;
export const drawerWidth = 260;

export const linkedInColor = '#0e76a8';
